registerComponent("blocks/rank-list-v2", function (component) {
/**
 * blocks/rank-list-v2 — SEM COMPORTAMENTO, de propósito.
 *
 * O widget é uma `<ol>` de links servida pronta pelo servidor. A numeração é do
 * próprio `<ol>` (contador de CSS na folha), e a coluna que gruda ao rolar é
 * `position: sticky` — CSS, não script.
 *
 * O arquivo existe para não haver dúvida de que a ausência é decisão, e não
 * esquecimento.
 */

});
